const NAMESPACE = "attachmentsCapsule";

const KEYS = {
    attachmentsCapsuleTitle: "attachmentsCapsuleTitle",
    removeBtnLabel: "removeBtnLabel",
    viewHistoryBtnLabel: "viewHistoryBtnLabel",
    addAttachmentLinkText: "addAttachmentLinkText",
    attachmentToAddLabel: "attachmentToAddLabel",
    selectAFileMessage: "selectAFileMessage",
    noAttachmentElementsMessage: "noAttachmentElementsMessage",
    uploadTimestampHeader: "uploadTimestampHeader",
    attachmentDefinitionNameHeader: "attachmentDefinitionNameHeader",
    filenameHeader: "filenameHeader",
    noteHeader: "noteHeader",
    statusHeader: "statusHeader",
    statusChangeUserHeader: "statusChangeUserHeader",
    statusChangeTimestampHeader: "statusChangeTimestampHeader",
    aiAssistantNameHeader: "aiAssistantNameHeader",
    aiAssistantRunTimestampHeader: "aiAssistantRunTimestampHeader",
    disablePopupMessage: "disablePopupMessage",
    confirmRemoveMessage: "confirmRemoveMessage",
    confirmRemoveDlgTitle: "confirmRemoveDlgTitle",
    attachmentHistoryLink: "attachmentHistoryLink",
    emptyTableMessage: "emptyTableMessage"
};

const MESSAGES = {
    [KEYS.attachmentsCapsuleTitle]: {
        value: "Attachments",
        comment: "Title for the attachments capsule"
    },
    [KEYS.removeBtnLabel]: {
        value: "Remove",
        comment: "Text for remove button"
    },
    [KEYS.viewHistoryBtnLabel]: {
        value: "View Attachment History",
        comment: "Text for view history button"
    },
    [KEYS.addAttachmentLinkText]: {
        value: "Add attachment",
        comment: "Text for add attachment link"
    },
    [KEYS.attachmentToAddLabel]: {
        value: "Attachment to add:",
        comment: "Text that asks user which attachment to add"
    },
    [KEYS.selectAFileMessage]: {
        value: "Select a file:",
        comment: "Text that asks user to select a file"
    },
    [KEYS.noAttachmentElementsMessage]: {
        value: "The selected form contains no attachment elements.",
        comment: "Text that lets user know form does not support attachments"
    },
    [KEYS.uploadTimestampHeader]: {
        value: "Upload Timestamp",
        comment: "Text for UploadTimestamp column"
    },
    [KEYS.attachmentDefinitionNameHeader]: {
        value: "Description",
        comment: "Text for attachment definition header"
    },
    [KEYS.filenameHeader]: {
        value: "Filename",
        comment: "Text for filename header"
    },
    [KEYS.noteHeader]: {
        value: "Note",
        comment: "Text for note header"
    },
    [KEYS.statusHeader]: {
        value: "Status",
        comment: "Text for status header"
    },
    [KEYS.statusChangeUserHeader]: {
        value: "Status Set By",
        comment: "Text for who updated status header"
    },
    [KEYS.statusChangeTimestampHeader]: {
        value: "Status timestamp",
        comment: "When was status changed header"
    },
    [KEYS.aiAssistantNameHeader]: {
        value: "AI Assistant",
        comment: "Text for AI Assistant name header"
    },
    [KEYS.aiAssistantRunTimestampHeader]: {
        value: "AI Run Timestamp",
        comment: "Text for when AI Assistant was run header"
    },
    [KEYS.disablePopupMessage]: {
        value: "Please disable pop-up blocking to use this feature.",
        comment: "Message to ask user to disable pop-up blocking"
    },
    [KEYS.confirmRemoveMessage]: {
        value: 'Are you sure you want to remove the attachment "{fileName}"? ',
        comment: "Text to ask user to confirm removal of attachment"
    },
    [KEYS.confirmRemoveDlgTitle]: {
        value: "Remove Attachment",
        comment: "Remove attachment dialogue title"
    },
    [KEYS.attachmentHistoryLink]: {
        value: "Attachment History for {fileName}",
        comment: "Link for attachment history"
    },
    [KEYS.emptyTableMessage]: {
        value: "No attachments have been uploaded.",
        comment: "Let user know that no attachments uploaded to this project"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
